import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

class SliderSnippets {
    constructor() {
        this.container = document.querySelectorAll('.js-slider-snippets');
    }

    init() {
        if (this.container.length > 0) {
            this.container.forEach((el) => {
                const identifier = el.dataset.identifier;

                let swiper = new Swiper(el, {
                    spaceBetween: 15,
                    slidesPerView: 1,
                    rewind: true,
                    autoplay: false,
                    navigation: {
                        nextEl: el.querySelector('.slider-next-' + identifier),
                        prevEl: el.querySelector('.slider-prev-' + identifier),
                    },
                    pagination: {
                        el: el.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                    breakpoints: {
                        769: {
                            slidesPerView: el.dataset.slidesPerViewTablet || 2,
                            spaceBetween: 15,
                        },
                        1024: {
                            slidesPerView: el.dataset.slidesPerViewDesktop || 4,
                            spaceBetween: 15,
                        },
                    },
                    modules: [Navigation, Pagination]
                });

                let lastModule, lastSection;

                swiper.on('slideChange', (swiper) => {
                    if (swiper.autoplay && swiper.autoplay.running) {
                        return;
                    }

                    const parents = getParents(swiper.el, '[data-module]');
                    let path = '';

                    if (parents.length > 0) {
                        parents.reverse();
                        path = parents.map((parent) => parent.dataset.module).join(' > ');
                    }

                    if (
                        (lastModule ===
                            path + ' > Slider > Slide ' + (swiper.realIndex + 1) &&
                            lastSection ===
                            swiper.el.closest('section[id],header[id],footer[id]').id) ||
                        ''
                    ) {
                        return;
                    }
                    lastSection =
                        swiper.el.closest('section[id],header[id],footer[id]').id || '';
                    lastModule = path + ' > Slider > Slide ' + (swiper.realIndex + 1);

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'nfx_event',
                        event_section:
                            swiper.el.closest('section[id],header[id],footer[id]').id || '',
                        event_modul: path + ' > Slider > Slide ' + (swiper.realIndex + 1),
                        event_element: 'slide-change',
                        event_thema: swiper.el.closest('[data-event-topic]')
                            ? swiper.el.closest('[data-event-topic]').dataset.eventTopic
                            : '',
                        event_klicktext: '',
                    });
                });
            });

            // update swiper on tab change
            document.addEventListener('tab-changed', (e) => {
                e.detail.tab.querySelectorAll('.swiper').forEach((el) => {
                    el.swiper.update();
                });
            });
        }
    }
}

export default new SliderSnippets();
